import React, { useRef, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { auth, db } from '../firebase-config'
import { collection, getDocs } from 'firebase/firestore'
import mapboxgl from '!mapbox-gl' // eslint-disable-line import/no-webpack-loader-syntax
import { ShopTemplate } from '../components/ShopTemplate'
import styles from './Home.module.css'

mapboxgl.accessToken = process.env.REACT_APP_MAP_ACCESS_TOKEN

const userRef = collection(db, 'users')

export const Home = () => {

  const location = useLocation()
  const user = auth.currentUser

  const mapContainer = useRef(null)
  const map = useRef(null)
  const [lng, setLng] = useState(13.05501)
  const [lat, setLat] = useState(47.80949)
  const [zoom, setZoom] = useState(11)
  const [shop, setShop] = useState()
  const [shops, setShops] = useState([])

  const markerClick = (shop) => {
    setShop(shop)
    window.location = '#shop-container'
  }

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLat(position.coords.latitude)
          setLng(position.coords.longitude)
        }
      )
    } 
  }

  async function getShops() {
    const data = await getDocs(userRef)
    const parsedData = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    setShops(parsedData)
  }

  useEffect(() => {
    getLocation()
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [lng, lat],
      zoom: zoom,
    })
  }, [lng, lat, zoom])

  useEffect(() => {
    getShops()
  }, [])

  useEffect(() => {
    shops.forEach((shop) => {
      const marker = new mapboxgl.Marker()
      marker.setLngLat(shop.geocoordinates).addTo(map.current)
      marker.getElement().addEventListener('click', () => markerClick(shop))
      marker.getElement().id = shop.shopname
    })
  }, [shops, lng, lat])

  useEffect(() => {
    if (shops.length !== 0 && user && location.hash === '#myshop') {
      const myShop = shops.filter(
        (shop) => auth.currentUser.uid === shop.id,
      )[0]
      const myShopMarker = document.getElementById(myShop.shopname)
      myShopMarker.click()
      setLng( myShop.geocoordinates[0])
      setLat( myShop.geocoordinates[1])
    }
  }, [shops, location])

  return (
    <div className={styles.front_page}>
      <div ref={mapContainer} className="map-container" />
      <div id="shop-container" className={styles.shop_container}>
        {shop && <ShopTemplate shop={shop} />}
      </div>
    </div>
  )
}
